import { Component, OnInit } from '@angular/core';

/**
 * @example
 * <lib-lib1></lib-lib1>
 */
@Component({
  selector: 'lib-lib1',
  template: `
    <p>
      lib1 works!
    </p>
    <lib-app-comp></lib-app-comp>
  `,
  styles: []
})
export class Lib1Component implements OnInit {
  constructor() {}

  ngOnInit() {}
}
